export const Palette = {
  primary: '#EF1724',
  error: '#F55265',
  succeed: '#009821',
  printed: '#8a4af3',
  confirmed: '#7D9BEA',
  notYetPrinted: '#e7bf2c'
};
